import angular from 'angular';
import deactivateCustomerAdminComponent from './deactivateCustomerAdmin.component';

let deactivateCustomerAdminModule = angular.module('deactivateCustomerAdmin', []).component('deactivateCustomerAdmin', deactivateCustomerAdminComponent);

export default deactivateCustomerAdminModule;



// WEBPACK FOOTER //
// ./app/components/deactivateCustomerAdmin/deactivateCustomerAdmin.js